
import { Component, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import LsDialog from "@/components/ls-dialog.vue";
import { RequestPaging, getCurrentTime, deepClone } from "@/utils/util";
import Parts from "@/components/model/parts.vue";
import Effect from "@/components/model/effect.vue";
import PopoverInput from "@/components/popover-input.vue";
import MaterialSelect from "@/components/material-select/index.vue";
import {
  apiModelList,
  apiModelDelete,
  apiModelShare,
  apiModelShareList,
  apiModelStatus,
  apiModelFastEdit,
  apiModelCopy,
  apiModelSetMarketStatus,
  apiModelCategoryList,
  apiModelSyncContent,
  apiModelDetail,
  apiModelDesignPartsLists,
  apiModelEffectLists,
  apiSupplyModelGetBuyShopList,
  apiModelEdit,
  apiModelEditItemImages,
} from "@/api/model";
import { apiShopLists } from "@/api/shop";
import { apiAliToken } from "@/api/app";
import feedback from "@/utils/feedback";
import JSZip from "jszip";
import OSS from "@/utils/oss.js";
@Component({
  components: {
    lsPagination,
    LsDialog,
    Parts,
    Effect,
    PopoverInput,
    MaterialSelect,
  },
})
export default class ModelList extends Vue {
  /** S Data **/

  pager: RequestPaging = new RequestPaging();
  dialogPager: RequestPaging = new RequestPaging();

  searchForm: any = {
    id: "",
    zh_cn_title: "",
    cate_id: "",
    sid: "",
    code: "",
    status: "",
    sort: "",
    remark: "",
  };
  marketStatus = 0;
  categoryList = [];
  model_id = "";
  dialogShare = false;
  share_shop_ids: any = [];

  shopList: any = [];
  shopTotal = 0;
  shopPrams = {
    id: 0,
    page_no: 1,
    page_size: 15,
    status: -10,
  };

  chooseModelId: any = [];
  chooseId: any = [];

  dialogShareList = false;
  shareList: any = [];

  shareStatusList: any = [
    { label: "全部", value: -10 },
    { label: "未分配", value: 0 },
    { label: "已分配", value: 1 },
  ];

  apiModelList = apiModelList;
  // 1=内测,2=禁用,3=启用
  statusList = [
    { label: "内测", value: 1 },
    { label: "下架", value: 2 },
    { label: "上架", value: 3 },
  ];

  pod_token = "";

  asyncVisbile = false;

  podForm = {
    private_url: localStorage.getItem("private_url") || "",
    token: localStorage.getItem("pod_token") || "",
  };
  market_sort = "asc";
  supply_sort = "asc";

  buyDialog = false;
  buyShopList: any = [];
  buyShopTotal = 0;
  buyShopPrams = {
    id: 0,
    page_no: 1,
    page_size: 15,
    status: -10,
  };

  ossClass: any = null;
  uploadVisible = false;
  imagesArr: any = [];
  loading = false;

  modelData: any = {};
  /** E Data **/
  getList() {
    this.pager.request({
      callback: apiModelList,
      params: {
        ...this.searchForm,
      },
    });
  }

  handleSelectionChange(value: any) {
    this.chooseModelId = value.map((item: any) => item.id);
  }
  // 添加
  handleAdd() {
    this.$router.push({ path: "/model/model_edit" });
  }

  handleEdit(id: string) {
    this.$router.push({
      path: "/model/model_edit",
      query: { id: id, mode: "edit" },
      params: { searchForm: this.searchForm, pager: this.pager as any },
    });
  }
  async handleBuyList() {
    let res = await apiSupplyModelGetBuyShopList(this.buyShopPrams);
    console.log(res);
    this.buyShopList = res.lists;
    this.buyShopTotal = res.total;
    this.buyDialog = true;
  }
  asyncToOtherPlatform() {
    localStorage.setItem("private_url", this.podForm.private_url);
    localStorage.setItem("pod_token", this.podForm.token);
    this.$message.success("设置成功");
    this.asyncVisbile = false;
  }
  async handleSync(id: number) {
    await this.$confirm("确定同步吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    });
    if (!this.podForm.private_url) {
      this.$message.error("请输入URL");
      return;
    }
    if (!this.podForm.token) {
      this.$message.error("请输入TOKEN");
      return;
    }
    let modelData = await apiModelDetail({ id });
    modelData.cate_id = [];
    modelData.remark = "";
    modelData.status = 2;
    delete modelData.id;
    delete modelData.partData;

    for (let i of modelData.spec_value) {
      delete i.id;
      for (let v of i.spec_list) {
        delete v.id;
      }
    }
    for (let i of modelData.spec_value_list) {
      delete i.id;
      delete i.create_time;
      delete i.update_time;
      delete i.delete_time;
    }
    let partDataRes = await apiModelDesignPartsLists({ model_id: id });
    let partData = partDataRes.lists;
    for (let i of partData) {
      delete i.id;
    }
    let effectDataRes = await apiModelEffectLists({ model_id: id });
    let effectData = effectDataRes.lists;
    for (let i of effectData) {
      delete i.id;
    }
    let data = {
      modelData: modelData,
      partData: partData,
      effectData: effectData,
    };
    fetch(`${this.podForm.private_url}/platformapi/model.modelList/syncModel`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        version: "3.1.0",
        token: this.podForm.token,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.code == 1) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
  }
  setMarketStatus(id: any, value: any) {
    let ids = [];
    if (!id) {
      ids = this.chooseModelId;
    } else {
      ids = [id];
    }
    apiModelSetMarketStatus({
      ids: ids,
      market_status: value ? 1 : 0,
    }).then((res: any) => {
      this.getList();
    });
  }

  handleChangeValue(id: number, value: number, key: string) {
    apiModelFastEdit({ id: Number(id), [key]: value }).then((res: any) => {
      this.$message.success("success");
      this.getList();
    });
  }

  async handleStatus(value: number, id: string) {
    if (value == 1) {
      await feedback.confirm("是否确认改为内测");
    } else if (value == 2) {
      await feedback.confirm("是否确认下架");
    } else if (value == 3) {
      await feedback.confirm("是否确认上架");
    }
    apiModelStatus({ id: id, status: value }).then((res: any) => {
      this.getList();
    });
  }

  handleShare(row: any) {
    this.model_id = row?.id;
    if (!row) {
      // apiShopLists({ page_size: 99 }).then((res: any) => {
      //   this.shareList = res.lists;
      // });
      console.log(
        "🚀 ~ ModelList ~ handleShare ~ this.chooseId:",
        this.chooseModelId,
      );
      this.shopPrams.id = this.chooseModelId.join(",");
    } else {
      this.shopPrams.id = row.id;
    }
    this.handleShareList();
    this.dialogShare = true;
  }

  handleSelectionShop(value: any) {
    this.chooseId = value.map((item: any) => item.id);
  }

  handleShareList() {
    apiModelShareList({ ...this.shopPrams }).then((res: any) => {
      this.shareList = res.lists;
      this.shopTotal = res.count;
    });
  }

  handleToShare(id: any) {
    let ids =
      this.chooseModelId.length > 0 ? this.chooseModelId : [this.model_id];
    apiModelShare({
      ids: ids,
      shop_ids: id ? id : this.chooseId.join(","),
      share_type: 1,
    }).then((res: any) => {
      // this.$message.success("分配成功");
      if (this.chooseModelId) {
        this.dialogShare = false;
      } else {
        this.handleShareList();
      }
    });
  }
  async cancelShare(id: string) {
    await this.$confirm("是否确认取消分配");
    apiModelShare({
      ids: [this.model_id],
      shop_ids: id,
      share_type: 2,
    }).then((res: any) => {
      // this.$message.success("取消分配成功");
      this.handleShareList();
    });
  }

  // 重置搜索
  reset(): void {
    const refs = this.$refs.searchFormRef as HTMLFormElement;
    refs.resetFields();
    this.searchForm = {
      id: "",
      zh_cn_title: "",
      cate_id: "",
      sid: "",
      code: "",
      status: "",
      sort: "",
      remark: "",
    };
  }

  // 编辑
  handleCopy(id: number) {
    apiModelCopy({ id: id }).then((res: any) => {
      this.getList();
    });
  }
  // 删除
  handleDelete(id: number) {
    apiModelDelete({ id: id }).then((res: any) => {
      this.getList();
    });
  }

  getShopList() {
    apiShopLists({ page_size: 99 }).then((res: any) => {
      this.shopList = res.lists;
    });
  }

  getCategory() {
    apiModelCategoryList({}).then((res: any) => {
      this.categoryList = res.lists;
    });
  }

  SyncContent() {
    apiModelSyncContent({ ids: this.chooseModelId }).then((res: any) => {
      this.getList();
    });
  }

  changeSortType(type: string) {
    let sort = "";
    if (type == "market_sort") {
      this.market_sort = this.market_sort == "asc" ? "desc" : "asc";
      this.supply_sort == "asc";
      sort = `${type}-${this.market_sort}`;
    } else {
      this.supply_sort = this.supply_sort == "asc" ? "desc" : "asc";
      this.market_sort = "asc";
      sort = `${type}-${this.supply_sort}`;
    }
    this.searchForm.sort = sort;
    this.getList();
  }

  async showCarousel(row: any) {
    let res = await apiModelDetail({ id: row.id });
    this.modelData = res;
    this.imagesArr = [];
    this.uploadVisible = true;
  }

  async uploadZip(file: any) {
    console.log("🚀 ~ ModelList ~ uploadZip ~ file:", file);
    try {
      let dataArr: any = [];
      const zip = await JSZip.loadAsync(file.raw);
      const fileEntries = Object.entries(zip.files);
      fileEntries.sort(([pathA], [pathB]) => pathA.localeCompare(pathB));
      this.loading = true;
      let isExistArr: any = {};
      let time = 0;
      for (let i = 0; i < fileEntries.length; i++) {
        const [relativePath, zipEntry] = fileEntries[i];
        if (!zipEntry.dir) {
          // 排除文件夹
          let spec_name = relativePath.split("/")[1];
          let fileName = relativePath.split("/")[2];
          if (!dataArr.find((item: any) => item.spec_name == spec_name)) {
            dataArr.push({ spec_name: spec_name, images: [] });
          }
          const content = await zipEntry.async("base64"); // 按需改格式
          let img = `data:image/${fileName.split(".")[1]};base64,${content}`;
          dataArr
            .find((item: any) => item.spec_name == spec_name)
            .images.push({ img: img, fileName: fileName });
        }
      }
      let imagesArr = [];
      for (let item of dataArr) {
        for (let imgItem of item.images) {
          if (isExistArr[imgItem.fileName]) {
            imgItem.img = isExistArr[imgItem.fileName];
          } else {
            time++;
            imgItem.img = await this.ossClass.putb64ToOss({
              content: imgItem.img,
              type: "effect",
              name: `${getCurrentTime(1)}/${imgItem.fileName}`,
            });
          }
          isExistArr[imgItem.fileName] = imgItem.img;
        }
        imagesArr.push({
          spec_name: item.spec_name,
          images: item.images.map((imgItem: any) => imgItem.img),
        });
      }
      this.imagesArr = imagesArr;
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }

  saveCarousel() {
    let model = deepClone(this.modelData);
    let spec_value_list = model.spec_value_list;
    let images_list: any = [];
    for (let images of this.imagesArr) {
      let spec_value = spec_value_list.find(
        (item: any) => item.spec_value_str == images.spec_name,
      );
      if (spec_value) {
        spec_value.images = images.images.join(",");
      }
      images_list.push({
        id: spec_value.id,
        images: spec_value.images,
      });
    }
    apiModelEditItemImages({ images_list: images_list }).then((res: any) => {
      this.$message.success("保存成功");
      this.uploadVisible = false;
      this.getList();
    });
  }

  /** E Methods **/

  /** S ods **/
  created() {
    apiAliToken().then((res: any) => {
      this.ossClass = new OSS(res);
    });
    this.getCategory();
    this.getShopList();
    this.getList();
  }
}
